import React from "react";
import { useSelector } from "react-redux";
import Modal from "../../Elements/Modal/Modal";
import Paytable from "../UI/Paytable/Paytable";
import styles from "../../Styles/Modules/Modal.module.scss";
import { APP_VERSION } from "../../settings";
import { useTranslation } from "react-i18next";
const InfoModal = () => {
  const { modalOpen } = useSelector((state) => state.modal);
  const { t } = useTranslation();
  return (
    <Modal
      name={"info"}
      modifier={"modalInfo"}
      active={modalOpen}
      title={"info"}
    >
      <div className={styles.modalInfoVersion}>
        <h3>
          {t("app_version")} : {APP_VERSION}
        </h3>
      </div>

      <Paytable />
    </Modal>
  );
};
export default InfoModal;
